import { Col, Row, Typography } from "antd";
import { useIntl } from "react-intl";
import { _eventBus } from "../../core/events/EventBus";
import { bookItAgainTree } from "../../Orchestrator/ConstantTree/BookItAgain/BookItAgainTree";
import { useRecState } from "../../Orchestrator/Recoils/Events/Recoil";
import { IBookedTrips, ISaleCardProps } from "../../Orchestrator/Types/Index";
import BookItAgainDateSelection from "../Common/BookItAgainDateSelection";
import BookItAgainTripItem from "./BookItAgainTripItem";
import "./SaleCard.css";

const SaleCard = <T extends IBookedTrips>({
  title,
  description,
}: ISaleCardProps<T>) => {
  const intl = useIntl();

  const [bookedTrips] = useRecState<IBookedTrips[]>("bookedTripsAtom");

  const showModal = (trip: IBookedTrips) => {
    // _eventBus.emit({
    //   eventName: bookItAgainTree.Calender.BestPrice,
    //   data: {
    //     selectedTrip: trip,
    //     calendarDayInterval: calendarDayInterval,
    //   },
    // });
    /**
     * Delay added because wait for API call.
     * Once API call success then open modal popup
     */
    // setTimeout(() => {
    _eventBus.emit({
      eventName: bookItAgainTree.Modal.Show,
      data: trip,
    });
    // }, 500);
  };

  return (
    <div className="sale-card thumbnail_slider">
      <Typography.Title
        className="fw-600 fs-34 mb-10 text-uppercase ff-wallop"
        level={3}
      >
        {title}
      </Typography.Title>
      <h6 className="sub-title">{description}</h6>

      {Array.isArray(bookedTrips) && bookedTrips.length > 0 ? ( // Check if trips is an array
        <div className="carousel">
          <div className="book-it-again-container">
            {
              bookedTrips?.slice(0, 3)?.map((trip, index) => (
                <div key={index} className="destinations_items">
                  <BookItAgainTripItem
                    trip={trip}
                    onShowModal={showModal}
                  />
                </div>
              ))
            }
          </div>
        </div>
      ) : (
        <Row gutter={[16, 16]} className="mt-20">
          <Col span={24} className="text-center">
            <Typography.Text>
              {intl.formatMessage({ id: "noTripsAvailableText" })}
            </Typography.Text>
          </Col>
        </Row>
      )}

      <BookItAgainDateSelection />
    </div>
  );
};

export default SaleCard;
